import { useBreakpoints } from "@vueuse/core";
import { computed } from "vue";

import { gridBreakpoints } from "@/utils";

export function useResponsiveness() {
  const breakpoints = useBreakpoints(gridBreakpoints);

  const isSmallerThanDesktopScreen = computed<boolean>(() => breakpoints.smaller("lg").value);
  const isSmallerThanTabletScreen = computed<boolean>(() => breakpoints.smaller("md").value);

  const isAtLeastTabletScreen = computed<boolean>(() => breakpoints.greaterOrEqual("md").value);

  return {
    breakpoints,

    isSmallerThanDesktopScreen,
    isSmallerThanTabletScreen,

    isAtLeastTabletScreen
  };
}
